import { render, staticRenderFns } from "./AllZyxx.vue?vue&type=template&id=5188be14&scoped=true&"
import script from "./AllZyxx.vue?vue&type=script&lang=js&"
export * from "./AllZyxx.vue?vue&type=script&lang=js&"
import style0 from "./AllZyxx.vue?vue&type=style&index=0&id=5188be14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5188be14",
  null
  
)

export default component.exports